import { createServerFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { authClient } from "../lib/authClient";
import z from "zod";
import { serverEnv } from "./env";

export const getSession = createServerFn({ method: "GET" }).handler(
  async () => {
    const cookieHeader = getRequestHeader("Cookie");
    if (!cookieHeader) return undefined;

    const headers = new Headers();
    headers.set("Cookie", cookieHeader);
    const session = await authClient.getSession(
      {},
      {
        headers,
      }
    );

    return session?.data;
  }
);

export const validateKey = createServerFn({ method: "GET" })
  .inputValidator(z.object({ key: z.string() }))
  .handler(async ({ data: { key } }) => {
    return key === serverEnv.API_KEY;
  });
